import ReactGA from "react-ga4";

// Khởi tạo GA
export const initGA = () => {
  const id = process.env.REACT_APP_GA_ID || "G-K7SWBQKHBX"; // Thay bằng ID thật nếu muốn
  ReactGA.initialize(id);
};

// Gửi pageview khi route thay đổi
export const trackPage = (url) => {
  ReactGA.send({ hitType: "pageview", page: url });
};

// Gửi event tùy chỉnh
export const trackEvent = ({ category, action, label, value }) => {
  ReactGA.event({ category, action, label, value });
};

// Gửi event khi gửi form
export const trackFormSubmit = (formName = "Generic Form") => {
  trackEvent({
    category: "Form",
    action: "Submit",
    label: formName,
  });
};

// Gửi event khi click link nội bộ
export const trackLinkClick = (label, location = "Body") => {
  trackEvent({
    category: "Navigation",
    action: "Click Link",
    label: `${label} @${location}`,
  });
};

// Gửi event khi click link ra ngoài
export const trackOutboundLink = (url) => {
  trackEvent({
    category: "Outbound",
    action: "Click External Link",
    label: url,
  });
};

// Gửi event khi click CTA (call-to-action)
export const trackCTA = (ctaName, position = "Floating") => {
  trackEvent({
    category: "CTA",
    action: "Click",
    label: `${ctaName} @${position}`,
  });
};
